export default "__VITE_ASSET__8e504e36__"